import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { getUserIsLoggedIn } from '../../Utils/helper';
import {
  LoginLogut,
  LoginSection,
  WelcomeText,
} from '../HomePage/NewHeader/MainHeader/styled';
import LoginPopupContainer from './LoginPopupContainer';
import { fireLoginEvent, loginSuccessMethod } from './utils';
import { navigateToLoginPage } from '../../Utils/redirections';
import { showNewLogin } from './NewLoginModule/common';

function LoginModule(props) {
  const { setCartItems, trackOrderHandler } = props;
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const [userDetails, setUserDetails] = useState();
  const [activeIndex, setActiveIndex] = useState();
  const [lowOpacity, setLowOpacity] = useState('');

  const category = {
    image:
      'https://images.myloapp.in/NestJsUploads/1680769104943-newloginicon.svg',
    tabName: userDetails?.username,
  };

  useEffect(() => {
    if (Cookies.get('react_user_properties')) {
      setUserDetails(JSON.parse(Cookies.get('react_user_properties')));
    }
  }, []);

  const handleLogin = () => {
    fireLoginEvent('viewed_web_login');
    if (showNewLogin()) {
      localStorage.setItem('redirectRoute', window.location.pathname);
      navigateToLoginPage();
    } else setShowLoginPopup(true);
  };

  const handleLogout = () => {
    __KP_LOGIN_SDK_INSTANCE__.handleKPLogout();
    sessionStorage.setItem('kwikpass_sso_tooltip', 'false');
    Cookies.remove('token', '/');
    //Cookies.remove("web_user_id_react", "/");
    Cookies.remove('cart_items', '/');
    if (setCartItems) setCartItems([]);
    setShowLogout(true);
  };
  const closeModal = () => {
    setShowLoginPopup(false);
  };
  const handleSuccess = async () => {
    const loginSuccess = await loginSuccessMethod();
    window.location.reload();
  };

  return (
    <>
      <LoginSection className="desktopSideDrawerLogout" margin={showLogout}>
        <>
          {!showLogout && getUserIsLoggedIn() ? (
            // <div className="logout">
            <div
              onClick={handleLogout}
              className={`desktopLoginButton ${lowOpacity}`}
            >
              <img
                src={userDetails?.profile_image}
                alt="login"
                className="accountIcon"
              />
              <div>
                <LoginLogut>{userDetails?.username}</LoginLogut>
                <WelcomeText logout>Logout</WelcomeText>
              </div>
            </div>
          ) : (
            // </div>
            <div
              className={`desktopLoginButton ${lowOpacity}`}
              onClick={() => {
                setLowOpacity('low');
                setTimeout(() => {
                  handleLogin();
                }, 200);
                setTimeout(() => {
                  setLowOpacity('');
                }, 2000);
              }}
            >
              <img
                src="https://images.myloapp.in/NestJsUploads/1682490044331-Group-127708.svg"
                alt="login"
                className="accountIcon"
              />
              <div>
                <WelcomeText>Welcome</WelcomeText>
                <LoginLogut>Login/Signup</LoginLogut>
              </div>
              {/* <TrackOrder trackOrderHandler={trackOrderHandler} /> */}
            </div>
          )}
        </>
      </LoginSection>
      {/* <Logout showButton={showLogout} handleLogout={handleLogout} /> */}
      <LoginPopupContainer
        closeModal={closeModal}
        showLoginPopup={showLoginPopup}
        handleSuccess={handleSuccess}
        setShowLoginPopup={setShowLoginPopup}
      />
    </>
  );
}

export default LoginModule;
